// extracted by mini-css-extract-plugin
module.exports = {"container":"advanced_container__2StB8","top_box":"advanced_top_box__1t6KT","button":"advanced_button__2i2PZ"};